<template>
    <!-- 品势单人形式 -->
    <div class="grade">
        <div class="tabbar">
            <div class="tabbar-item" :class="tabIndex==index?'tabbar-item-active':''" @click="handleChange(index)" v-for="(tab,index) in technicalDetails" :key="index">{{tab.rounds}}</div>
        </div>
            <div class="ps">
                <div class="ps-left">
                    <MyCharts  :eWidth="200" :eHight="250" :option="gaugeOption1"/>
                    <MyCharts  :eWidth="210" :eHight="250" :option="gaugeOption2"/>
                </div>
                <div   div class="ps-right">
                <div class="table">
                    
                    <div class="table-item active" >
                        <div class="cell name">裁判</div>
                        <div class="cell score" v-for="(referee,index) in scoreDetails" :key="index">{{referee.referee}}</div>
                    </div>

                    <div class="table-item"  >
                        <div class="cell name">表现力</div> 
                        <div class="cell score" v-for="(technical,index) in scoreDetails" :key="index">{{ technical.blueDetails['表现力'] }}</div>
                    </div>
                    <div class="table-item"  >
                        <div class="cell name">准确度</div> 
                        <div class="cell score" v-for="(technical,index) in scoreDetails" :key="index">{{ technical.blueDetails['准确度'] }}</div>
                    </div>
                </div>   
            </div>
        </div>
    </div>     
</template>

<script>
import MyCharts from '../../myecharts/MyEcharts'
export default {
  props:['technicalDetails'],
  components:{MyCharts},
  data () {
    return {
      tabIndex: 0,
      tabbarList:[
        {
          name:'第一场'
        },
        {
          name:'第二场'
        },
        {
          name:'第三场'
        }
      ],
      gaugeOption1:{
        series: [
          {
            type: 'gauge',
            startAngle: 90,
            endAngle: -360,
            color:'#244E8F',
            pointer: {
              show: false
            },
            progress: {
              show: true,
              overlap: false,
              roundCap: true,
              clip: false,
              itemStyle: {
                borderWidth: 2,
                borderColor: '#244E8F'
              }
            },
            axisLine: {
              lineStyle: {
                width:16,
              }
            },
            splitLine: {
              show: false,
              distance: 0,
              length: 10
            },
            axisTick: {
              show: false
            },
            //刻度
            axisLabel: {
              show: false,
              distance: 50
            },
            data: [
              {
                value: parseInt(this.technicalDetails[0].technicalDatas['表现力'].blueScore*100/6),
                //标题文字
                name: this.technicalDetails[0].technicalDatas['表现力'].blueScore+'/6',
                // name: 1+'/6',
                title: {
                  offsetCenter: ['0%', '-5%']
                },
                detail: {
                  valueAnimation: true,
                  offsetCenter: ['0%', '15%']
                }
              }
            ],
            //上面标题
            title: {
              fontSize: 14,
              fontWeight:700
            },
            //下面文字
            detail: {
              width: 60,
              height: 20,
              fontSize: 14,
              formatter: '表现力'
            }
          }
        ]
      },
      gaugeOption2:{
        series: [
          {
            type: 'gauge',
            startAngle: 90,
            endAngle: -360,
            color:'#05B3E2',
            pointer: {
              show: false
            },
            progress: {
              show: true,
              overlap: false,
              roundCap: true,
              clip: false,
              itemStyle: {
                borderWidth: 2,
                borderColor: '#05B3E2'
              }
            },
            axisLine: {
              lineStyle: {
                width:16,
              }
            },
            splitLine: {
              show: false,
              distance: 0,
              length: 10
            },
            axisTick: {
              show: false
            },
            //刻度
            axisLabel: {
              show: false,
              distance: 50
            },
            data: [
              {
                value: parseInt(this.technicalDetails[0].technicalDatas['准确度'].blueScore*100/4),
                // value:99,
                //标题文字
                name: this.technicalDetails[0].technicalDatas['准确度'].blueScore+'/4',
                // name: 1+'/6',
                title: {
                  offsetCenter: ['0%', '-5%']
                },
                detail: {
                  valueAnimation: true,
                  offsetCenter: ['0%', '15%']
                }
              }
            ],
            //上面标题
            title: {
              fontSize: 14,
              fontWeight:700
            },
            //下面文字
            detail: {
              width: 60,
              height: 20,
              fontSize: 14,
              formatter: '准确度'
            }
          }
        ]
      },
    }
  },
  mounted () {

  },
  methods: {
    handleChange (index) {
      this.tabIndex=index
    },
  },
  computed: {
    scoreDetails (){
      return this.technicalDetails[0].scoreDetails
    },
    technicalDatas (){
      return this.technicalDetails[0].technicalDatas
    },
  },
  
}
</script>

<style lang="scss" scoped>
//打分
.grade{
 //tabbar
    .tabbar{
        display: flex;
        box-sizing: border-box;
        justify-content: space-between;
        height: 50px;
        .tabbar-item{
            background-color: #F1F1F1;
            box-sizing: border-box;
            max-width: 360px;
            width: 95%;
            height: 50px;
            line-height: 50px;
            text-align: center;
            color: #333333;
            font-weight: bold;
            cursor: pointer;
            margin-right: 5px;
        }
        &last-child{
            margin-right: 0 !important;
        }
        .tabbar-item-active{
            border-bottom: 4px solid #2773D5;
        }
    }
    .ps{
        display: flex;
        justify-content: flex-start;
        .ps-left{
            width: 420px;
            height: 250px;
            display: flex;
            justify-content: space-between;
            box-sizing: border-box;
        }
        .ps-right{
            width: 100%;
            height: 250px;
            padding-top: 40px;
            padding-left: 15px;
            .table-item{
                background-color: #ffffff;
                display: flex;
                justify-content: space-evenly;
                flex-direction: row;
                .cell{
                    min-width: 100px;
                    height: 60px;
                    line-height: 60px;
                    text-align: center;
                    color: #333333;
                    font-weight: bold;
                }
                .name{
                    width: 100px;
                }
            }
            .active{
                background-color: #EDEDED;
            }
            
            }
    } 
}

</style>


// WEBPACK FOOTER //
// src/comm/components/modal/taekwondo/content/GradeContent.vue